<template>
  <div class="container">

    <form @submit.prevent="submitEditProfile" novalidate>
      <breadcrumb-group :items="breadcrumbItems"/>

      <heading-one>お客さま情報の変更</heading-one>

      <errors-alert :errors="errors" column-only="true" :items="inputItemsMb"></errors-alert>

      <wizard-group class="_mb-md-60 _mb-sm-20">
        <main-wizard :active-index="0" type="userinfo"></main-wizard>
      </wizard-group>

      <p>変更内容をご入力のうえ、「確認画面へ」を押してください。</p>

      <section>

        <table-group>
          <heading-two class="_mt-50">お客さま情報</heading-two>
          <table-box>
            <table-body>
              <table-row>
                <table-header>
                  お客さま番号
                </table-header>
                <table-data>
                  {{userData.account_id}}
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  氏名<small>（漢字）</small>
                  <btn-tooltip slot="tooltip" target="kanjiTooltip" class="-question"></btn-tooltip>
                  <tooltips-item slot="tooltip" target="kanjiTooltip" placement="righttop" clazz="question-box">
                    ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
                  </tooltips-item>
                </table-header>
                <table-data>
                  <label class="name">{{userData.lastname_kanji}}</label>
                  <label class="name">{{userData.firstname_kanji}}</label>
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  氏名<small>（フリガナ）</small>
                  <btn-tooltip slot="tooltip" target="kanaTooltip" class="-question"></btn-tooltip>
                  <tooltips-item slot="tooltip" target="kanaTooltip" placement="righttop" clazz="question-box">
                    ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
                  </tooltips-item>
                </table-header>
                <table-data>
                  <label class="name">{{userData.lastname_kana}}</label>
                  <label class="name">{{userData.firstname_kana}}</label>
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  生年月日
                </table-header>
                <table-data>
                  {{displayBth}}
                </table-data>
              </table-row>
              <!--<table-row>
                <table-header>
                  性別
                </table-header>
                <table-data>
                  {{displaySex}}
                </table-data>
              </table-row>-->
              <table-row v-if="auUser && hasPhoneAu">
                <table-header>
                  au携帯電話番号または<br>UQ mobile 電話番号
                </table-header>
                <table-data>
                  {{displayPhoneAu}}
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  電話番号<small>（その他）<small class="moji">【半角数字】</small></small>
                </table-header>
                <table-data :hasError="errors['phone_mobile']">
                  <input-group :errors="errors" :propNames="['phone_mobile']">
                    <inputgroup-append>
                      <input-phone :phone="{phone1: userData.phone_mobile_1, phone2: userData.phone_mobile_2, phone3: userData.phone_mobile_3}" id="phone_mobile" @input="setPhoneMobile"></input-phone>
                    </inputgroup-append>
                    <input-label x-ms-format-detection="none">
                      入力例：  090-****-****
                    </input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  毎月のご返済日
                </table-header>
                <table-data>
                  毎月{{userData.contractual_repayment_cycle}}日
                </table-data>
              </table-row>
            </table-body>
          </table-box>

          <heading-two class="_mt-50">ご自宅情報</heading-two>
          <table-box>
            <table-body>
              <table-row>
                <table-header colspan="2">
                  郵便番号<small class="moji">【半角数字※ハイフン不要】</small>
                </table-header>
                <table-data :hasError="errors['postcode']">
                  <input-group :errors="errors" :propNames="['postcode']">
                    <inputgroup-append>
                      <input-item v-model="userData.postcode" type="text" class="-md" id="postcode" :maxlength="7"></input-item>
                    </inputgroup-append>
                    <input-label>入力例：1234567</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-harfleft" rowspan="4">
                  ご住所<small>（漢字）</small>
                </table-header>
                <table-header class="-harfright">
                  都道府県<small class="moji">【全角】</small>
                </table-header>
                <table-data :hasError="errors['address_region']">
                  <input-group :errors="errors" :propNames="['address_region']">
                    <input-group>
                      <input-item v-model="userData.address_region" type="text" class="-md" id="address_region" :maxlength="60"></input-item>
                      <input-label>入力例：東京都</input-label>
                    </input-group>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-harfright">
                  市区町村<small class="moji">【全角】</small>
                </table-header>
                <table-data :hasError="errors['address_city']">
                  <input-group :errors="errors" :propNames="['address_city']">
                    <input-item v-model="userData.address_city" id="address_city" class="-lg" :maxlength="60"></input-item>
                    <input-label>入力例：港区</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-harfright">
                  地名・番地以下<small class="moji">【全角】</small>
                </table-header>
                <table-data :hasError="errors['address_street']">
                  <input-group :errors="errors" :propNames="['address_street']">
                    <input-item v-model="userData.address_street" id="address_street" class="-lg" :maxlength="60"></input-item>
                    <input-label>入力例：○○○１－１ー１</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header class="-harfright">建物名・部屋番号<small class="moji">【全角】</small></table-header>
                <table-data :hasError="errors['address_building']">
                  <input-group :errors="errors" :propNames="['address_building']">
                    <input-item v-model="userData.address_building" id="address_building" class="-lg" :maxlength="60"></input-item>
                    <input-label>入力例：○○マンション１０１号室</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header colspan="2">
                  ご住所<small>（フリガナ）<small class="moji">【全角カナ・全角英数】</small></small>
                </table-header>
                <table-data :hasError="errors['address_kana']">
                  <input-group :errors="errors" :propNames="['address_kana']">
                    <text-area v-model="userData.address_kana" id="address_kana1" class="furigana" :maxlength="166" excludeLineCode="true"></text-area>
                    <input-label>入力例：トウキョウトミナトク○○○１－１－１○○マンション１０１ゴウシツ<br>※スペースを空けず、つめてご入力ください。</input-label>
                  </input-group>
                </table-data>
              </table-row>
            </table-body> <!-- table-body -->
          </table-box>
          <table-box>
            <table-body>
              <table-row>
                <table-header>お住まいの種類</table-header>
                <table-data>
                  <btngroup-radio>
                    <btn-radio v-for="(homeType, index) in home_types" v-model="userData.home_type"
                               :key="'homeType' + index" :id="'homeType' + index" name="homeTypeRadio"
                               :value="homeType['value']" :label="homeType['name']">
                    </btn-radio>
                  </btngroup-radio>
                </table-data>
              </table-row>
              <table-row>
                <table-header>
                  居住開始年月<small class="moji">【半角数字】</small>
                </table-header>
                <table-data :hasError="errors['nky_ngt']">
                  <input-group :errors="errors" :propNames="['nky_ngt']">
                    <inputgroup-append>
                      <input-item v-model="nkyNgtYyyy" type="text" class="-xs" id="nkyNgtYyyy" :maxlength="4" @change="setNkyNgt"></input-item>
                      <input-append>年</input-append>
                      <input-item v-model="nkyNgtMm" type="text" class="-xs" id="nkyNgtMm" :maxlength="2" @change="setNkyNgt"></input-item>
                      <input-append>月~</input-append>
                    </inputgroup-append>
                    <input-label>入力例：2019年3月～</input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header>住宅ローンもしくは家賃のお支払い<small>(月額)<small class="moji">【半角数字】</small></small>
                  <btn-tooltip slot="tooltip" target="housingLoanTooltip" class="-question"></btn-tooltip>
                  <tooltips-item slot="tooltip" target="housingLoanTooltip" placement="righttop">
                    ご自身のご負担がない場合は「0」を入力してください。
                  </tooltips-item>
                </table-header>
                <table-data :hasError="errors['rent_loan_amount']">
                  <input-group :errors="errors" :propNames="['rent_loan_amount']">
                    <inputgroup-append>
                      <input-item v-model="userData.rent_loan_amount" type="text" class="-sm" id="housingLoan" :maxlength="10"></input-item>
                      <input-append>円／月</input-append>
                    </inputgroup-append>
                    <input-label>入力例：75000</input-label>
                  </input-group>
                </table-data>
              </table-row>
            </table-body>
          </table-box>
          <table-box>
            <table-body>
              <table-row>
                <table-header>ご家族<small>（配偶者さま）</small></table-header>
                <table-data>
                  <btngroup-radio>
                    <btn-radio v-for="(marriageStatus, index) in marriage_statuses" v-model="userData.marriage_status"
                               :key="'marriageStatus' + index" :id="'marriageStatus' + index" name="marriageStatus"
                               :value="marriageStatus['value']" :label="marriageStatus['name']">
                    </btn-radio>
                  </btngroup-radio>
                </table-data>
              </table-row>
              <table-row>
                <table-header>ご家族<small>（お子さま）</small></table-header>
                <table-data>
                  <btngroup-radio>
                    <btn-radio v-for="(numberOfChildren, index) in number_of_children" v-model="userData.number_of_children"
                               :key="'numberOfChildren' + index" :id="'numberOfChildren' + index" name="numberOfChildren"
                               :value="numberOfChildren['value']" :label="numberOfChildren['name']">
                    </btn-radio>
                  </btngroup-radio>
                </table-data>
              </table-row>
            </table-body> <!-- table-body -->
          </table-box>
        </table-group>

        <btngroup-double class="-margin-lg">
          <btn-main slot="main" class="-main" @click.prevent="submitEditProfile">
            確認画面へ
          </btn-main>
          <btn-back slot="back" class="-back -sm" routerName="mb023">
            戻る
          </btn-back>
        </btngroup-double>
      </section>

    </form>

  </div>
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataForMemberLambdaInvoke, editProfileLambdaInvoke } from '../utils/LambdaHelper'
import { homeTypes, marriageStatuses, numberOfChildren, inputItemsMb } from '../constants/constant'
import userData from '../components/mixin/UserData'

import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import HeadingOne from '../components/heading/HeadingOne'
import HeadingTwo from '../components/heading/HeadingTwo'
import HeadingThree from '../components/heading/HeadingThree'
import BtnTooltip from '../components/button/BtnTooltip'
import TooltipsItem from '../components/tooltip/TooltipsItem'
import CardGroups from '../components/card/CardGroups'
import CardHeader from '../components/card/CardHeader'
import CardBody from '../components/card/CardBody'
import CardBox from '../components/card/CardBox'
import BtnToggle from '../components/button/BtnToggle'
import CollapseItem from '../components/collapse/CollapseItem'
import BtnMain from '../components/button/BtnMain'
import BtnBack from '../components/button/BtnBack'
import BtnInput from '../components/button/BtnInput'
import BtnRadio from '../components/button/BtnRadio'
import BtnSelect from '../components/button/BtnSelect'
import BtngroupRadio from '../components/button/BtngroupRadio'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtngroupDouble from '../components/button/BtngroupDouble'
import MainWizard from '../components/wizard/MainWizard'
import WizardGroup from '../components/wizard/WizardGroup'
import InputGroup from '../components/input/InputGroup'
import InputItem from '../components/input/InputItem'
import InputgroupAppend from '../components/input/InputgroupAppend'
import InputAppend from '../components/input/InputAppend'
import InputLabel from '../components/input/InputLabel'
import InputPhone from '../components/input/InputPhone'
import ErrorsAlert from '../components/alert/ErrorsAlert'
import TextArea from '../components/input/TextArea'
export default {
  name: 'Mb-024',
  metaInfo: {
    title: 'お客さま情報の変更｜お客さま情報の確認・変更',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報'}
    ]
  },
  mixins: [userData],
  components: {
    TextArea,
    ErrorsAlert,
    InputPhone,
    TableGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    HeadingTwo,
    HeadingThree,
    BtnTooltip,
    TooltipsItem,
    CardGroups,
    CardHeader,
    CardBody,
    CardBox,
    BtnToggle,
    CollapseItem,
    BtnMain,
    BtnBack,
    BtnInput,
    BtnRadio,
    BtnSelect,
    BtngroupRadio,
    BtngroupSingle,
    BtngroupDouble,
    WizardGroup,
    MainWizard,
    InputGroup,
    InputItem,
    InputgroupAppend,
    InputAppend,
    InputLabel
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'お客さま情報の確認・変更',
        routerName: 'mb023'
      },
      {
        text: 'お客さま情報の変更',
        active: true
      }
      ],
      errors: {},
      home_types: homeTypes,
      marriage_statuses: marriageStatuses,
      number_of_children: numberOfChildren,
      hasPhoneMobile: false,
      hasPhoneAu: false,
      userData: {
        id_type: '',
        account_id: '',
        firstname_kanji: '',
        lastname_kanji: '',
        firstname_kana: '',
        lastname_kana: '',
        bth: '',
        sex: '',
        phone_au_1: '',
        phone_au_2: '',
        phone_au_3: '',
        phone_mobile_1: '',
        phone_mobile_2: '',
        phone_mobile_3: '',
        repayment_date: '',
        contractual_repayment_cycle: '',
        postcode: '',
        address_region: '',
        address_city: '',
        address_street: '',
        address_building: '',
        address_kana: '',
        home_type: '',
        nky_ngt: '',
        rent_loan_amount: '',
        marriage_status: '',
        number_of_children: ''
      },
      isDisabled: false,
      nkyNgtYyyy: '',
      nkyNgtMm: '',
      inputItemsMb: inputItemsMb
    }
  },
  methods: {
    submitEditProfile () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.setNkyNgt()
        initCredentials().then(res => {
          editProfileLambdaInvoke(this.userData).then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              this.$router.push({name: 'mb027'})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  },
  mounted () {
    try {
      getUserDataForMemberLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key].toString().trim()
          }
        }
        this.setNkyNgtYyyy()
        this.setNkyNgtMm()
        this.setHasPhoneAu()
        this.setHasPhoneMobile()
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .table-data {
    vertical-align: middle;
  }
  .furigana {
    font-family: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Mb024.vue